import { coneSparks } from '../effects/factories';
import type { EffectDefinition } from '../effects/types';
import { createModuleIcon } from './icons';
import type { ModulePresentation } from './types';
const SeekerIcon = createModuleIcon(
	<>
		<circle className="module-icon__line" cx="17" cy="15" r="8" />
		<circle className="module-icon__fill" cx="17" cy="15" r="3" />
		<path className="module-icon__thin" d="M17 3v5M17 22v5M5 15h5M24 15h5" />
		<path className="module-icon__thick" d="M5 27c3-4 6-6 10-6" />
		<path className="module-icon__fill" d="M4 22l6 3-5 4z" />
	</>,
);
const color = '#168aad';
const SEEKER_ORBIT_OFFSETS = [0, Math.PI] as const;
const effects: readonly EffectDefinition[] = [
	{
		id: 'module:seeker:lock',
		lifetime: 0.34,
		layer: 'air',
		render: (frame, painter) => {
			const radius = 27 - frame.easeOut(2) * 16;
			painter.ring(frame.x, frame.y, radius, 2 * frame.slope + 0.3, frame.color, frame.fout);
			for (let index = 0; index < 4; index += 1) {
				const angle = (index * Math.PI) / 2 + frame.rotation;
				const x = frame.x + Math.cos(angle) * radius;
				const y = frame.y + Math.sin(angle) * radius;
				painter.lineAngle(
					x,
					y,
					angle + Math.PI,
					6,
					2 * frame.fout,
					index % 2 ? '#fff' : frame.color,
					frame.fout,
				);
			}
		},
	},
	coneSparks({ id: 'module:seeker:hit', lifetime: 0.3, count: 8, distance: 36, cone: 0.7, length: 9, stroke: 1.5 }),
];
export const seekerModule: ModulePresentation = {
	id: 'seeker',
	icon: SeekerIcon,
	meta: {
		color,
		displayColor: '#168aad',
		tint: '#e2f4f8',
	},
	effects,
	renderProjectile: ({ ctx, projectile }) => {
		const phase = projectile.life * 7 + projectile.id;
		ctx.save();
		ctx.fillStyle = color;
		for (const offset of SEEKER_ORBIT_OFFSETS) {
			ctx.beginPath();
			ctx.arc(
				projectile.position.x + Math.cos(phase + offset) * (projectile.radius + 5),
				projectile.position.y + Math.sin(phase + offset) * (projectile.radius + 5),
				1.7,
				0,
				Math.PI * 2,
			);
			ctx.fill();
		}
		ctx.restore();
	},
};
